import BigNumber from 'bignumber.js'
import { cloneDeep } from 'lodash'
import Currency from '@/models-ts/Currency'

export default class AbstractTransaction {
  created_at: string
  event: string
  wallet: string
  icon: string
  title: string
  tx_id: string
  currency: Currency
  amount: BigNumber
  constructor(data: Partial<AbstractTransaction>) {
    Object.assign(this, cloneDeep(data))
  }
}
